<template>
  <div class="special-offers">
    <div class="row">
      <div
        v-for="(offer, offerIndex) in offers"
        :key="offer.Id"
        :data-contentful-text="offer.Id"
        class="col-xs-12 col-sm-6"
      >
        <div class="special-offer">
          <div class="row">
            <div class="col-xs-4">
              <div class="special-offer__image-wrapper">
                <a
                  :style="titleLinkStyles"
                  :href="offer.LinkUrl"
                  target="_blank"
                  @click="handleImageClick(offer, offerIndex)"
                >
                  <img
                    :src="offer.Image.File.Url"
                    :alt="offer.Image.Description"
                    :title="offer.Image.Description"
                    class="responsive-img special-offer__image"
                  >
                </a>
              </div>
            </div>
            <div class="col-xs-8">
              <h4 class="special-offer__title">
                <a
                  :style="titleLinkStyles(offer)"
                  :href="offer.LinkUrl"
                  target="_blank"
                  @click="handleTitleClick(offer, offerIndex)"
                >
                  {{ offer.Title }}
                </a>
              </h4>
              <h4
                v-if="offer.Subtitle"
                :style="subTitleStyles(offer)"
                class="special-offer__subtitle"
              >
                {{ offer.Subtitle }}
              </h4>
              <div class="special-offer__description">
                {{ offer.Description }}
              </div>
              <div class="special-offer__cta-wrapper">
                <a
                  :href="offer.LinkUrl"
                  class="special-offer__cta"
                  target="_blank"
                  @click="handleCtaClick(offer, offerIndex)"
                >
                  {{ offer.LinkText }}
                  <font-awesome-icon :icon="faChevronRight" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoogleAnalytics from '@Shared/lib/google-analytics'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'

export default {
  name: 'SpecialOffers',
  components: {
    FontAwesomeIcon
  },
  props: {
    offers: { type: Array, default: function () { return [] }, required: true },
    slotNumberOffset: { type: Number, default: 0, required: false }
  },
  data () {
    return {
      faChevronRight
    }
  },
  methods: {
    titleLinkStyles (offer) {
      let styles = {}

      if (offer.TitleColor !== null && offer.TitleColor) {
        styles.color = offer.TitleColor
      }

      return styles
    },
    subTitleStyles (offer) {
      let styles = {}

      if (offer.SubtitleColor !== null && offer.SubtitleColor) {
        styles.color = offer.SubtitleColor
      }

      return styles
    },
    handleImageClick (offer, promoSlotNumber) {
      GoogleAnalytics.trackEvent(`Promotion space ${this.promoSlotNumberWithOffset(promoSlotNumber)}`, 'click', `${offer.Title} Image`)
    },
    handleTitleClick (offer, promoSlotNumber) {
      GoogleAnalytics.trackEvent(`Promotion space ${this.promoSlotNumberWithOffset(promoSlotNumber)}`, 'click', `${offer.Title} Header`)
    },
    handleCtaClick (offer, promoSlotNumber) {
      GoogleAnalytics.trackEvent(`Promotion space ${this.promoSlotNumberWithOffset(promoSlotNumber)}`, 'click', `Shop ${offer.Title}`)
    },
    promoSlotNumberWithOffset (promoSlotNumber) {
      promoSlotNumber = promoSlotNumber + 1 // switch from zero-based integer to 1-based

      return this.slotNumberOffset + promoSlotNumber // apply the slotNumberOffset prop. this keeps the slot numbers contiguous between feature/regular offers
    }
  }
}
</script>

<style lang="scss" scoped>
.special-offers {
  margin-bottom: 20px;

  @media screen and (min-width: $screen-sm-min) {
    margin-bottom: 40px;
  }
}

.special-offer {
  margin-bottom: 20px;

  &__image {
    width: 100%;
    height: 100%;
  }

  &__title,
  &__subtitle {
    font-size: 20px;
    font-weight: 700;

    & > a {
      color: #000;
    }
  }

  &__description {
    font-size: 14px;
    line-height: 20px;
  }

  &__cta {
    font-size: 16px;
    font-weight: bold;
  }

  @media screen and (min-width: $screen-sm-min) {
    margin-bottom: 40px;

    &__title,
    &__subtitle {
      font-size: 24px;
      margin-bottom: 10px;
    }

    &__description {
      font-size: 18px;
      padding-right: 20px;
      line-height: 30px;
    }

    &__cta {
      font-size: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/default/home/special-offers/components/SpecialOffers.vue